module.exports = __webpack_public_path__ + "static/media/file.5a96a892.svg";